import React from 'react';
import { Card } from '@hz-design-system/web-ui';
import { Trans, useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import Classes from '../ProfileSidebar.scss';

const SellerCompanyLegalInfo = ({
  sellerCompanyLegalInfo,
}: {
  sellerCompanyLegalInfo: {
    name: string;
    btw: string;
    kvk: string;
  };
}) => {
  const i18n = useI18nContext();

  return sellerCompanyLegalInfo.name || sellerCompanyLegalInfo.btw || sellerCompanyLegalInfo.kvk ? (
    <Card kind="rounded" className={Classes.wrap}>
      <div className={Classes.card}>
        <div className={Classes.cardSection}>
          <div className={Classes.sellerCompanyLegalInfo}>
            <div className={Classes['sellerCompanyLegalInfo-label']}>
              {i18n.t('sellerProfile.companyLegalInfo.label')}
            </div>
            {sellerCompanyLegalInfo.name && (
              <div className={Classes['sellerCompanyLegalInfo-item']}>
                <Trans
                  i18nKey="sellerProfile.companyLegalInfo.name"
                  tagName="span"
                  className={Classes['sellerCompanyLegalInfo-itemLabel']}
                />
                <span className="ProfileSidebar-sellerCompanyLegalInfo-itemContent">{sellerCompanyLegalInfo.name}</span>
              </div>
            )}
            {sellerCompanyLegalInfo.btw && (
              <div className={Classes['sellerCompanyLegalInfo-item']}>
                <Trans
                  i18nKey="sellerProfile.companyLegalInfo.btw"
                  tagName="span"
                  className={Classes['sellerCompanyLegalInfo-itemLabel']}
                />
                <span className="ProfileSidebar-sellerCompanyLegalInfo-itemContent">{sellerCompanyLegalInfo.btw}</span>
              </div>
            )}
            {sellerCompanyLegalInfo.kvk && (
              <div className={Classes['sellerCompanyLegalInfo-item']}>
                <Trans
                  i18nKey="sellerProfile.companyLegalInfo.kvk"
                  tagName="span"
                  className={Classes['sellerCompanyLegalInfo-itemLabel']}
                />
                <span className="ProfileSidebar-sellerCompanyLegalInfo-itemContent">{sellerCompanyLegalInfo.kvk}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </Card>
  ) : null;
};

export default SellerCompanyLegalInfo;
